// src/pages/Dashboard/Admin/DetailsAdherents/components/AttendancePanel.jsx

import React, { useMemo } from "react";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

import DashboardDataTable from "./DashboardDataTable";

import {
  calculateAttendanceStats,
  formatDate,
  safeArray,
} from "../utils/adherentDashboardUtils";

function StatusBadge({ present }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold ring-1 ${
        present
          ? "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:ring-emerald-500/20"
          : "bg-rose-50 text-rose-700 ring-rose-200 dark:bg-rose-500/10 dark:text-rose-300 dark:ring-rose-500/20"
      }`}
    >
      {present ? <FaCheckCircle /> : <FaTimesCircle />}
      {present ? "Présent" : "Absent"}
    </span>
  );
}

export default function AttendancePanel({ attendances }) {
  const rows = useMemo(() => {
    return safeArray(attendances).sort(
      (a, b) =>
        new Date(b?.date_presence || 0).getTime() -
        new Date(a?.date_presence || 0).getTime()
    );
  }, [attendances]);

  const stats = useMemo(() => calculateAttendanceStats(rows), [rows]);

  return (
    <div className="space-y-4">
      <div className="grid gap-3 sm:grid-cols-3">
        <div className="rounded-2xl border border-indigo-200 bg-indigo-50 p-4 text-indigo-700 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em]">
            Séances
          </p>
          <p className="mt-1 text-xl font-semibold text-slate-950 dark:text-white">
            {stats.total}
          </p>
        </div>

        <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-4 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em]">
            Présences
          </p>
          <p className="mt-1 text-xl font-semibold text-slate-950 dark:text-white">
            {stats.presents}
          </p>
        </div>

        <div className="rounded-2xl border border-rose-200 bg-rose-50 p-4 text-rose-700 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em]">
            Absences
          </p>
          <p className="mt-1 text-xl font-semibold text-slate-950 dark:text-white">
            {stats.absents}
          </p>
        </div>
      </div>

      <DashboardDataTable
        minWidth="760px"
        columns={[
          {
            key: "date",
            label: "Date",
            render: (row) => formatDate(row?.date_presence, true),
          },
          {
            key: "presence",
            label: "Présence",
            render: (row) => <StatusBadge present={!!row?.presence} />,
          },
          {
            key: "group",
            label: "Groupe / cours",
            render: (row) =>
              row?.Group?.nom ||
              row?.group_nom ||
              row?.nom_groupe ||
              row?.cours_nom ||
              "—",
          },
          {
            key: "createdAt",
            label: "Saisie",
            render: (row) => formatDate(row?.createdAt),
          },
        ]}
        rows={rows}
        emptyMessage="Aucune présence enregistrée."
      />
    </div>
  );
}